import { render } from "./StavoviZaposlenihComponent.vue?vue&type=template&id=77eb1551&scoped=true&lang=html"
import script from "./StavoviZaposlenihComponent.vue?vue&type=script&lang=js"
export * from "./StavoviZaposlenihComponent.vue?vue&type=script&lang=js"

import "./StavoviZaposlenihComponent.vue?vue&type=style&index=0&id=77eb1551&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-77eb1551"

export default script